<template>
  <div id="viewer">
    <ZoomControl @zoom-in="zoomIn" @zoom-out="zoomOut" />
    <BuildingInformation
      :building="pickedBuilding"
      :show="showBuildingInfo"
      @close-info="showBuildingInfo = false"
      @report-data="getReportDataIssuePathWithId( pickedBuilding.attributes.identificatie )"
    />
    <AppControls 
      ref="appControls"
      :rotation="camRotationZ" 
      :building="pickedBuilding"
      :show-building-info="showBuildingInfo"
      @download-image="downloadImage"
      @orient-north="orientNorth"
      @set-background-map="setBackgroundMap"
      @update-sun="updateSun"
      @update-datetime="updateDatetime"
      @select-place="moveToPlace"
    />
    <ThreeViewer
      ref="threeviewer"
      :tiles-url="tilesUrl"
      :basemap-options="basemapOptions"
      @object-picked="objectPicked"
      @cam-offset="onCamOffset"
      @cam-rotation-z="onCamRotationZ"
    />
    <div
      v-if="true"
      id="attribution"
      class="has-background-white has-text-grey"
    >
      <p>
        <span v-if="basemapOptions.attribution">
          {{ $t("viewer.baselayer1") }}
          <a
            v-if="basemapOptions.attributionURL"
            href="https://www.pdok.nl/"
          >
            {{ basemapOptions.attribution }}
          </a>
          <span v-else>
            {{ basemapOptions.attribution }}
          </span> |
        </span>
        <a :href="'https://docs.3dbag.nl/'+$route.params.locale+'/copyright' ">© 3D BAG by tudelft3d</a>
      </p>
    </div>
    <div id="debug-panel" />
  </div>
</template>

<script>
import AppControls from '@/components/AppControls.vue';
import BuildingInformation from '@/components/BuildingInformation.vue';
import ThreeViewer from '@/components/ThreeViewer.vue';
import ZoomControl from '@/components/ZoomControl.vue';

export default {
    name: 'Viewer',
    components: {
        AppControls,
        BuildingInformation,
        ThreeViewer,
        ZoomControl,
    },
    data() {
        return {
            customTilesUrl: '/static/tiles.json',
            BAG3DVersion: this.$root.$data[ 'versions' ][ this.$root.$data[ "latest" ] ],
            camOffset: {
                x: 400,
                y: 400,
                z: 400
            },
            camRotationZ: 0,
            basemapPreset: 'topo',
            basemaps: {
                topo: {
                    name: "Topo Achtergrondkaart",
                    icon: "map"
                },
                aerial: {
                    name: "Luchtfoto 2020",
                    icon: "map"
                }
            },
            tileset: 'lod22',
            lods: {
                lod22: {
                    name: "LoD 2.2",
                    icon: "home"
                },
                lod13: {
                    name: "LoD 1.3",
                    icon: "home"
                },
                lod12: {
                    name: "LoD 1.2",
                    icon: "home"
                }
            },
            pickedBuilding: {
                batchID: "-",
                attributes: []
            },
            showBuildingInfo: false,
        };
    },
    computed: {
        filteredDataArray() {
            return this.data.filter( ( option ) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf( this.name.toLowerCase() ) >= 0;
            } );
        },

        tilesUrl: function () {
            return this.customTilesUrl;
        },

        basemapOptions: function () {

            const sources = {
                topo: {
                    type: "wmts",
                    attribution: "MapTiler",
                    attributionURL: "https://www.maptiler.com/",
                    options: {
                        provider: "maptiler",
                        url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0?',
                        layer: 'standaard',
                        style: 'default',
                        tileMatrixSet: "EPSG:28992",
                        service: "WMTS",
                        request: "GetTile",
                        version: "1.0.0",
                        format: "image/png"
                    }
                },
                aerial: {
                    type: "wmts",
                    attribution: "PDOK",
                    attributionURL: "https://www.pdok.nl/",
                    options: {
                        provider: "pdok",
                        url: 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0?',
                        layer: '2020_ortho25',
                        style: 'default',
                        tileMatrixSet: "EPSG:28992",
                        service: "WMTS",
                        request: "GetTile",
                        version: "1.0.0",
                        format: "image/png"
                    }
                },
            };
            return sources[this.basemapPreset];
        },
        reportDataIssueUrl: function () {
            return `https://docs.google.com/forms/d/e/1FAIpQLSe6JZ66MYdCygTZNAEyP8qQUCllNa_FQoMJA3SqqaYkdkKDdw/viewform?usp=pp_url&entry.927112266=${ escape( window.location.href ) }`;
        }
    },
    watch: {
        $route( to, from ) {
            if ( to.query.lod ) {
                this.tileset = to.query.lod;
            }

        },

        tileset( to, from ) {
            if ( to != from ) {
                let q = Object.assign( {}, this.$router.currentRoute.query );
                q.lod = to;

                this.$router.push(
                    { url: '/', query: q }
                ).catch( err => {} );
            }
        }
    },
    mounted() {
        if ( this.$router.currentRoute.query.lod ) {
            this.tileset = this.$router.currentRoute.query.lod;
        }
    },
    methods: {
        zoomIn: function() {
            this.$refs.threeviewer.zoomIn();
        },
        zoomOut: function() {
            this.$refs.threeviewer.zoomOut();
        },
        downloadImage: function() {
            this.$refs.threeviewer.downloadImage();
        },
        updateSun: function( date ) {
            this.$refs.threeviewer.setSun(date);
        },
        updateDatetime: function(date) {
            // console.log("--date-->", date);
            this.$refs.threeviewer.updateDatetime(date);
        },
        onCamOffset: function ( event ) {
            this.camOffset = event;
        },
        setBackgroundMap: function({type}) {
          if (type === "aerial") {
            this.basemapPreset = "aerial";
          } else {
            this.basemapPreset = "topo";
          }
        },
        onCamRotationZ: function ( value ) {
            this.$refs.appControls.$refs.compass.setRotation( value );
        },       
        orientNorth: function ( value ) {
            this.$refs.threeviewer.pointCameraToNorth();
        },
        moveToPlace: function ( res ) {
            if ( res ) {
                this.$router.push( {
                    path: '/' + this.$route.params.locale + '/viewer',
                    query: {
                        rdx: res.rd_x,
                        rdy: res.rd_y,
                        ox: this.camOffset.x,
                        oy: this.camOffset.y,
                        oz: this.camOffset.z,
                        placeMarker: true
                    }
                } );
            }
        },
        objectPicked: function ( event ) {
            if ( event ) {
                this.pickedBuilding = event;
                this.showBuildingInfo = true;
            } else {
                this.showBuildingInfo = false;
            }
        },
        getReportDataIssuePathWithId: function ( identificatie ) {
            window.open(this.reportDataIssueUrl + '&entry.2078829974=' + identificatie, '_blank' );
            // window.open( this.reportDataIssueUrl + `&entry.547110854=${ identificatie }`, '_blank' );
        }
    }
};
</script>

<style>
#building-info {
    position: absolute;
    bottom: 0.5rem;
    margin: 0 0.5rem;
}
.table-value {
    overflow-x: auto;
}
#building-info .message-body {
    overflow: auto;
    max-height: 1%;
}
#map-options {
    position: absolute;
    margin: 0px;
    top: 0.5rem;
    margin: 0 0.5rem;
}
#viewer {
    width: 100%;
    height: 100%;
}
#attribution {
    position: absolute;
    padding: 0 0.1rem;
    font-size: 13px;
    line-height: 15px;
    right: 0;
    bottom: 0;
    opacity: 0.8;
}
</style>
